import { TableCell } from "@material-ui/core";
import { Grid, Table, TableRow, TableHead, TableBody, Typography, CircularProgress, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import { Button } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { Can } from "../Can";
import { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import React, { useRef, useEffect, useState, useCallback, useReducer } from "react";
import toastError from "../../errors/toastError";
import { format, parseISO } from "date-fns";
import { CropFree, SignalCellular4Bar, SignalCellularConnectedNoInternet0Bar, SignalCellularConnectedNoInternet2Bar } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { KTSVG } from "../../../_metronic/helpers";
import ConfirmationModal from "../ConfirmationModal";
import QrcodeModal from "../QrcodeModal";
import WhatsAppModal from "./modal";
import { toast } from "react-toastify";
import socket from "../../hooks/useSocket";
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined';
import PublishIcon from '@material-ui/icons/Publish';
import ImportWhatsappMessageTableModal from "./ImportWhatsappMessage/tableModal";
import CheckSupportEmail from "../../helpers/CheckSupportEmail";

const useStyles = makeStyles(theme => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(1),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
    customTableCell: {
        display: "flex",
        alignItems: "center",
    },
    tooltip: {
        backgroundColor: "#f5f5f9",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: theme.typography.pxToRem(14),
        border: "1px solid #dadde9",
        maxWidth: 450,
    },
    tooltipPopper: {
        textAlign: "center",
    },
    buttonProgress: {
        color: green[500],
    },
    modalStyle: {
        padding: '90px',
        minWidth: '310px',
        overflowY: 'scroll',
        "@media (max-width: 740px)": {
            padding: '0px !important',
            marginTop: '65px'
        }
    },
    customButton:{
        display: "inline-block",
        "& svg": {
            color: "#757575", 
        },
        "&:hover": {
            "& svg": {
                color: "#009688"
            }
        }
    }
}));

const CustomToolTip = ({ title, content, children }) => {
    const classes = useStyles();

    return (
        <Tooltip
            arrow
            classes={{
                tooltip: classes.tooltip,
                popper: classes.tooltipPopper,
            }}
            title={
                <React.Fragment>
                    <Typography gutterBottom color="inherit">
                        {title}
                    </Typography>
                    {content && <Typography>{content}</Typography>}
                </React.Fragment>
            }
        >
            {children}
        </Tooltip>
    );
};

const deletedConnections = [];

const deleteConnection = (whatsappId) => {
    if (whatsappId) {
        whatsappId = Number(whatsappId);
        if (deletedConnections.findIndex((item) => item == whatsappId) == -1) {
            deletedConnections.push(whatsappId);
        }
    }
};

const reducer = (state, action) => {
    if (action.type === "LOAD_WHATSAPPS") {
        const whatsapps = action.payload;
        const newWhatsapps = [];

        whatsapps.forEach((whatsapp) => {
            const whatsappIndex = state.findIndex((q) => q.id === whatsapp.id);
            if (whatsappIndex !== -1) {
                state[whatsappIndex] = whatsapp;
            } else {
                newWhatsapps.push(whatsapp);
            }
        });

        return [...state, ...newWhatsapps];
    }
  
    if (action.type === "UPDATE_WHATSAPPS") {
        const whatsapp = action.payload;
        const whatsappIndex = state.findIndex((q) => q.id == whatsapp.id);

        if (whatsappIndex !== -1) {
            state[whatsappIndex] = whatsapp;
            return [...state];
        } else {
            return [whatsapp, ...state];
        }
    }

    if (action.type === "DELETE_WHATSAPPS") {
        const whatsappId = action.payload;

        const whatsappIndex = state.findIndex((q) => q.id == whatsappId);

        if (whatsappIndex !== -1) {
            state.splice(whatsappIndex, 1);
        }
        deleteConnection(whatsappId);
        return [...state];
    }

    if (action.type === "RESET") {
      return [];
    }
  };

const WhatsAppTable = () => {

    const { user } = useContext(AuthContext);
    const classes = useStyles();
    const [qrModalOpen, setQrModalOpen] = useState(false);
    const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const confirmationModalInitialState = {
		action: "",
		title: "",
		message: "",
		whatsAppId: "",
		open: false,
	};
    const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
    const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
    const [importWhatsappMessages, setImportWhatsappMessages] = useState(false);
    const [importSessionModalOpen, setImportSessionModalOpen] = useState(false);
    const [importSessionJson, setImportSessionJson] = useState("");
    const [importSessionLoading, setImportSessionLoading] = useState(false);
    const [filteredWhatsApps, dispatch] = useReducer(reducer, []);
    const [moduleIds, setModuleIds] = useState([]);
    const waEmbedRef = useRef({
        pendingCode: null,
        pendingWaIds: null,
        pendingPin: null,
        pendingWhatsappId: null,
        callApiOnFinish: null,
    });
    const [waPinModalOpen, setWaPinModalOpen] = useState(false);
    const [waBusinessPin, setWaBusinessPin] = useState("");

    useEffect(() => {
        let isMounted = true;
        const abortController = new AbortController();

        const fetchWhatsapps = async () => {
            try {
                const { data } = await api.get("/whatsappListAll", { 
                    params: { disabled: '1' }, 
                    signal: abortController.signal,
                });
                if (!isMounted) return;
                dispatch({ type: "LOAD_WHATSAPPS", payload: data.filter(w => w.state == 1) });
                data.map(w => {
                    if (w.state == 0) deleteConnection(w.id);
                })

                const { data: dataCompanyModules } = await api.get(`/companyModules/${user.adminId}`, {
                    signal: abortController.signal,
                });
                if (!isMounted) return;

                if (Array.isArray(dataCompanyModules)) {
                    setModuleIds(dataCompanyModules.map(dc => dc.moduleId));
                }

            } catch (err) {
                if (!isMounted || err.name == 'AbortError') return;
                console.error({err});
                toastError(err);
            }
        }

        fetchWhatsapps();

        return () => {
            isMounted = false;
            abortController.abort();
        };
    }, []);

    const FACEBOOK_APP_ID = process.env.REACT_APP_INSTAGRAM_ID; // App padrão
    const WHATSAPP_APP_ID = process.env.REACT_APP_WHATSAPP_ID; // App do WhatsApp

    useEffect(() => {

        if (document.getElementById("facebook-jssdk")) return;

        const script = document.createElement("script");
        script.id = "facebook-jssdk";
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        document.body.appendChild(script);

        script.onload = () => {
            if (!window.FB) return;
            // Inicializa o primeiro App ID como padrão
            window.FB.init({
                appId: FACEBOOK_APP_ID,
                cookie: true,
                xfbml: true,
                version: "v19.0",
            });

        };
    }, []);

    useEffect(() => {
        // const loadFacebookSDK = () => {
        //         (function (d, s, id) {
        //             let js, fjs = d.getElementsByTagName(s)[0];
        //             if (d.getElementById(id)) return;
        //             js = d.createElement(s); js.id = id;
        //             js.src = "https://connect.facebook.net/en_US/sdk.js";
        //             fjs.parentNode.insertBefore(js, fjs);
        //         }(document, 'script', 'facebook-jssdk'));

        //         window.fbAsyncInit = function () {
        //             window.FB.init({
        //                 appId: '3735689559994297',
        //                 cookie: true,
        //                 xfbml: true,
        //                 version: 'v19.0'
        //             });
        //         };
        // };

        // loadFacebookSDK();

        // const loadWhatsFacebookSDK = () => {
        //     (function (d, s, id) {
        //         let js, fjs = d.getElementsByTagName(s)[0];
        //         if (d.getElementById(id)) return;
        //         js = d.createElement(s); js.id = id;
        //         js.src = "https://connect.facebook.net/en_US/sdk.js";
        //         fjs.parentNode.insertBefore(js, fjs);
        //     }(document, 'script', 'facebook-jssdk'));

        //     window.fbAsyncInit = function () {
        //         window.FB.init({
        //             appId: '388423584297385',
        //             cookie: true,
        //             xfbml: true,
        //             version: 'v22.0'
        //         });
        //     };
        // };

        // loadWhatsFacebookSDK();
        
        let isMounted = true;
        const abortController = new AbortController();

        const callApiOnFinish = async (phone_number_id, waba_id, code, pin, coexistenceOnboarding = false) => {
            console.log("[WaBusiness-Embed] callApiOnFinish", {
                phone_number_id,
                waba_id,
                hasCode: !!code,
                hasPin: !!pin,
                coexistenceOnboarding,
            });
            try {
                const body = { wabaId: waba_id, coexistenceOnboarding: !!coexistenceOnboarding };
                if (phone_number_id) body.phoneNumberId = phone_number_id;
                if (code) body.code = code;
                if (pin) body.pin = pin;
                if (waEmbedRef.current.pendingWhatsappId) {
                    body.idWhatsapp = waEmbedRef.current.pendingWhatsappId;
                }
                await api.post("/whatsapp/updateInstaToken", body, {
                    signal: abortController.signal,
                });
                if (!isMounted) return;
                console.log("[WaBusiness-Embed] updateInstaToken sucesso");
                toast.success(i18n.t("connections.toasts.connected") || "WhatsApp Business conectado!");
                waEmbedRef.current.pendingWhatsappId = null;
            } catch (error) {
                if (!isMounted || error.name === "AbortError") return;
                console.error("[WaBusiness-Embed] updateInstaToken erro:", error?.response?.data || error.message);
                toastError(error);
            }
        };

        waEmbedRef.current.callApiOnFinish = callApiOnFinish;
        window.__waEmbedFbCallback = (response) => {
            if (response.authResponse?.code) {
                const code = response.authResponse.code;
                console.log("[WaBusiness-Embed] fbLoginCallback code recebido", { hasPendingWaIds: !!waEmbedRef.current.pendingWaIds });
                if (waEmbedRef.current.pendingWaIds) {
                    const pending = waEmbedRef.current.pendingWaIds;
                    waEmbedRef.current.callApiOnFinish?.(
                        pending.phone_number_id,
                        pending.waba_id,
                        code,
                        waEmbedRef.current.pendingPin,
                        pending.coexistenceOnboarding
                    );
                    waEmbedRef.current.pendingWaIds = null;
                    waEmbedRef.current.pendingPin = null;
                } else {
                    waEmbedRef.current.pendingCode = code;
                }
            } else {
                console.warn("[WaBusiness-Embed] fbLoginCallback sem code", response);
            }
        };

        const handleWaEmbedFinish = (data) => {
            const coexistenceOnboarding = data.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING";
            const { phone_number_id, waba_id } = data.data || {};
            console.log("[WaBusiness-Embed] postMessage finish", {
                event: data.event,
                phone_number_id,
                waba_id,
                coexistenceOnboarding,
            });
            if (!waba_id) {
                console.warn("[WaBusiness-Embed] finish sem waba_id", data.data);
                return;
            }
            if (!coexistenceOnboarding && !phone_number_id) {
                console.warn("[WaBusiness-Embed] FINISH sem phone_number_id", data.data);
                return;
            }
            if (waEmbedRef.current.pendingCode) {
                callApiOnFinish(
                    phone_number_id,
                    waba_id,
                    waEmbedRef.current.pendingCode,
                    waEmbedRef.current.pendingPin,
                    coexistenceOnboarding
                );
                waEmbedRef.current.pendingCode = null;
                waEmbedRef.current.pendingPin = null;
            } else {
                waEmbedRef.current.pendingWaIds = { phone_number_id, waba_id, coexistenceOnboarding };
            }
        };

        const listener = (event) => {
            if (!event.origin.endsWith("facebook.com")) return;
            try {
                const data = JSON.parse(event.data);
                if (data.type !== "WA_EMBEDDED_SIGNUP") return;
                if (data.event === "FINISH" || data.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING") {
                    handleWaEmbedFinish(data);
                } else if (data.event === "CANCEL") {
                    const { current_step } = data.data || {};
                    console.warn("[WaBusiness-Embed] postMessage CANCEL", current_step);
                    waEmbedRef.current.pendingPin = null;
                } else if (data.event === "ERROR") {
                    const { error_message } = data.data || {};
                    console.error("[WaBusiness-Embed] postMessage ERROR", error_message);
                    toast.error(error_message || "Erro no cadastro WhatsApp Business");
                    waEmbedRef.current.pendingPin = null;
                }
            } catch (_) {}
        };

        window.addEventListener("message", listener);

        return () => {
            window.removeEventListener("message", listener);
            window.__waEmbedFbCallback = null;
            isMounted = false;
            abortController.abort();
        };
    }, []);
    
    // Alterna entre os Apps
    const switchFacebookApp = (appId, version) => {
        if (window.FB) {
            window.FB.init({
                appId,
                cookie: true,
                xfbml: true,
                version,
            });

            console.log(`Facebook SDK agora usa AppID: ${appId}`);
        }
    };

    //CADASTRO INSTAGRAM
    const responseFacebook = async (response, idWhatsapp) => {
    
        if (response.status === 'connected') {
    
            const accessToken = response.authResponse.accessToken;
    
            // Obter informações do usuário
            const userInfo = await new Promise((resolve) => {
                window.FB.api('/me', { fields: 'name,picture' }, resolve);
            });
    
            // Verifique o status de login para mais detalhes
            const statusResponse = await new Promise((resolve) => {
                window.FB.getLoginStatus(resolve);
            });
    
            if (statusResponse.status === 'connected') {
                const accessToken = statusResponse.authResponse.accessToken;
    
                // Obter as páginas
                const accountsResponse = await new Promise((resolve) => {
                    window.FB.api('/me/accounts', { access_token: accessToken }, resolve);
                });
    
                if (accountsResponse && !accountsResponse.error) {
                    const pages = accountsResponse.data;
    
                    // Pegue apenas a primeira página
                    if (pages.length > 0) {
                        const firstPage = pages[0];
    
                        // Obter o ID da conta do Instagram associada à página
                        const pageDetails = await new Promise((resolve) => {
                            window.FB.api(`/${firstPage.id}?fields=instagram_business_account`, { access_token: accessToken }, resolve);
                        });
    
                        const instagramAccount = pageDetails.instagram_business_account;
                        if (instagramAccount) {
                            
                            // Chamar a API para atualizar o token
                            await api.post("/whatsapp/updateInstaToken", {
                                idWhatsapp,
                                accessToken: accessToken,
                                pageId: firstPage.id,
                                instagramId: instagramAccount.id,
                                pageName: firstPage.name
                            });
                        } else {
                            console.log(`A página ${firstPage.name} não está associada a uma conta do Instagram.`);
                        }
                    } else {
                        console.log("Nenhuma página encontrada.");
                    }
                } else {
                    console.error("Erro ao obter páginas:", accountsResponse.error);
                }
    
                console.log("Usuário agora está conectado:", statusResponse);
            } else {
                console.log("Usuário não está conectado ou não autorizou a aplicação.");
            }
        } else {
            console.log("Login falhou:", response);
    
            // Obter informações do usuário
            const userInfo = await new Promise((resolve) => {
                window.FB.api('/me', { fields: 'name,picture' }, resolve);
            });
            console.log(userInfo);
    
            // Verifique o status de login para mais detalhes
            const statusResponse = await new Promise((resolve) => {
                window.FB.getLoginStatus(resolve);
            });
    
            if (statusResponse.status === 'connected') {
                const accessToken = statusResponse.authResponse.accessToken;
    
                // Obter as páginas
                const accountsResponse = await new Promise((resolve) => {
                    window.FB.api('/me/accounts', { access_token: accessToken }, resolve);
                });
    
                if (accountsResponse && !accountsResponse.error) {
                    const pages = accountsResponse.data;
    
                    // Pegue apenas a primeira página
                    if (pages.length > 0) {
                        const firstPage = pages[0];
                        console.log(`ID da página: ${firstPage.id}, Nome: ${firstPage.name}`);
    
                        // Obter o ID da conta do Instagram associada à página
                        const pageDetails = await new Promise((resolve) => {
                            window.FB.api(`/me/accounts?fields=instagram_business_account`, { access_token: accessToken }, resolve);
                        });

                        // Verificar se há dados e se existe uma conta do Instagram associada
                        if (pageDetails.data && pageDetails.data.length > 0) {
                            const firstItem = pageDetails.data[0];
                            const instagramAccount = firstItem.instagram_business_account;
                            
                            if (instagramAccount) {
                                console.log(`ID da conta do Instagram: ${instagramAccount.id}`);
                                
                                // Chamar a API para atualizar o token
                                await api.post("/whatsapp/updateInstaToken", {
                                    idWhatsapp,
                                    accessToken: accessToken,
                                    pageId: firstPage.id,
                                    instagramId: instagramAccount.id,
                                    pageName: firstPage.name
                                });
                            } else {
                                console.log(`A página ${firstPage.name} não está associada a uma conta do Instagram.`);
                            }
                        } else {
                            console.log(`Nenhum dado retornado para a página ${firstPage.name}.`);
                        }
                    } else {
                        console.log("Nenhuma página encontrada.");
                    }
                } else {
                    console.error("Erro ao obter páginas:", accountsResponse.error);
                }
    
                console.log("Usuário agora está conectado:", statusResponse);
            } else {
                console.log("Usuário não está conectado ou não autorizou a aplicação.");
            }
        }
    };

     // Iniciar Facebook Login (troca para o app correto antes de abrir o login)
     const handleFacebookLogin = (renderProps) => {
        switchFacebookApp(FACEBOOK_APP_ID, "v19.0"); // Define o app correto
        renderProps.onClick();
    };

    // CADASTRO WHATSAPP BUSINESS (Embedded Signup - Meta)
    const WHATSAPP_EMBED_CONFIG_ID = process.env.REACT_APP_WHATSAPP_EMBED_CONFIG_ID;

    // extras gerados pelo portal Meta (Embedded Signup Builder / Quickstart) — habilita Coexistência no v4
    const DEFAULT_WA_EMBED_EXTRAS = {
        featureType: "whatsapp_business_app_onboarding",
        sessionInfoVersion: "3",
        version: "v4",
        features: [{ name: "app_only_install" }],
    };

    const parseWaEmbedExtras = () => {
        const raw = process.env.REACT_APP_WHATSAPP_EMBED_EXTRAS;
        if (raw === undefined || raw === null) return DEFAULT_WA_EMBED_EXTRAS;
        const trimmed = String(raw).trim();
        if (trimmed === "" || trimmed === "{}") return {};
        try {
            return JSON.parse(trimmed);
        } catch (_) {
            console.warn("[WaBusiness-Embed] REACT_APP_WHATSAPP_EMBED_EXTRAS inválido; usando extras do portal Meta.");
            return DEFAULT_WA_EMBED_EXTRAS;
        }
    };

    const launchWhatsAppSignup = (pin) => {
        if (!WHATSAPP_APP_ID) {
            toast.error("REACT_APP_WHATSAPP_ID não configurado.");
            return;
        }
        if (!WHATSAPP_EMBED_CONFIG_ID) {
            toast.error("REACT_APP_WHATSAPP_EMBED_CONFIG_ID não configurado (ID da configuração Facebook Login for Business).");
            return;
        }
        if (!/^\d{6}$/.test(String(pin || ""))) {
            toast.error("Crie um PIN de 6 dígitos para o WhatsApp Business.");
            return;
        }
        waEmbedRef.current.pendingPin = String(pin);
        switchFacebookApp(WHATSAPP_APP_ID, "v22.0");

        const callback = typeof window.__waEmbedFbCallback === "function" ? window.__waEmbedFbCallback : (r) => { if (r.authResponse?.code) console.log("Code recebido; aguarde o postMessage FINISH."); };
        const embedExtras = parseWaEmbedExtras();
        console.log("[WaBusiness-Embed] FB.login extras", embedExtras);
        window.FB.login(callback, {
            config_id: WHATSAPP_EMBED_CONFIG_ID,
            response_type: "code",
            override_default_response_type: true,
            extras: embedExtras,
        });
    };

    const handleOpenWaPinModal = (whatsAppId) => {
        waEmbedRef.current.pendingWhatsappId = whatsAppId || null;
        setWaBusinessPin("");
        setWaPinModalOpen(true);
    };

    const handleStartWaEmbeddedSignup = () => {
        launchWhatsAppSignup(waBusinessPin);
        setWaPinModalOpen(false);
    };

    useEffect(() => {

        const whatsappEventName = `whatsapp-${user.adminId}`;
        const whatsappEventFunction = async (data) => {
			// verificar se veio com a flag de duplicado, para retornar ao usuário
			if (data?.action === "update" && data?.duplicated && data?.whatsapp?.id) {
				// verificar se a conexão está entre as filtradas
				let resp = filteredWhatsApps.filter(item => item.id == data.whatsapp.id);
				if (resp.length >= 1) { toast.error('Este número já possuí uma conexão no sistema.'); }
			}

			if (data?.action == "update") {
				const newWhatsapp = data.whatsapp;
                
				// verificar se a conexão já foi deletada
				if (newWhatsapp.state == false) {
                    dispatch({ type: "DELETE_WHATSAPPS", payload: newWhatsapp.id });
					return;
				}
				const deletedIndex = deletedConnections.findIndex((item) => (newWhatsapp.id == item));

				if (deletedIndex !== -1) {
                    dispatch({ type: "DELETE_WHATSAPPS", payload: newWhatsapp.id });
					return;
				}

                dispatch({ type: "UPDATE_WHATSAPPS", payload: newWhatsapp });

                if (
                    String(newWhatsapp.moduleId) === "4" &&
                    (newWhatsapp.status === "passkey" || newWhatsapp.status === "PAIRING")
                ) {
                    setSelectedWhatsApp(newWhatsapp);
                    setQrModalOpen(true);
                }
			}

			if (data?.action == "delete") {
				const whatsappId = data.whatsappId;
                dispatch({ type: "DELETE_WHATSAPPS", payload: whatsappId });
			}
		};
		socket.on(whatsappEventName, whatsappEventFunction);
		return () => {
            socket.off(whatsappEventName, whatsappEventFunction);
        };
	}, []);

    const renderStatusToolTips = whatsApp => {
        return (
            <div className={classes.customTableCell}>
                {whatsApp.status === "DISCONNECTED" && (
                    <CustomToolTip
                        title={i18n.t("connections.toolTips.disconnected.title")}
                        content={i18n.t("connections.toolTips.disconnected.content")}
                    >
                        <SignalCellularConnectedNoInternet0Bar color="secondary" />
                    </CustomToolTip>
                )}
                {whatsApp.status === "OPENING" && (
                    <CircularProgress size={24} className={classes.buttonProgress} />
                )}
                {whatsApp.status === "qrcode" && (
                    <CustomToolTip
                        title={i18n.t("connections.toolTips.qrcode.title")}
                        content={i18n.t("connections.toolTips.qrcode.content")}
                    >
                        <CropFree />
                    </CustomToolTip>
                )}
                {(whatsApp.status === "passkey" || whatsApp.status === "qrcode_scanned") && (
                    <CustomToolTip
                        title={i18n.t("connections.toolTips.passkey.title")}
                        content={i18n.t("connections.toolTips.passkey.content")}
                    >
                        <CircularProgress size={24} className={classes.buttonProgress} />
                    </CustomToolTip>
                )}
                {whatsApp.status === "CONNECTED" && (
                    <CustomToolTip title={i18n.t("connections.toolTips.connected.title")}>
                        <SignalCellular4Bar style={{ color: green[500] }} />
                    </CustomToolTip>
                )}
                {(whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") && (
                    <CustomToolTip
                        title={i18n.t("connections.toolTips.timeout.title")}
                        content={i18n.t("connections.toolTips.timeout.content")}
                    >
                        <SignalCellularConnectedNoInternet2Bar color="secondary" />
                    </CustomToolTip>
                )}
            </div>
        );
    };

    const handleOpenConfirmationModal = (action, whatsAppId) => {
		if (action === "disconnect") {
			setConfirmModalInfo({
				action: action,
				title: i18n.t("connections.confirmationModal.disconnectTitle"),
				message: i18n.t("connections.confirmationModal.disconnectMessage"),
				whatsAppId: whatsAppId,
			});
		}

		if (action === "delete") {
			setConfirmModalInfo({
				action: action,
				title: i18n.t("connections.confirmationModal.deleteTitle"),
				message: i18n.t("connections.confirmationModal.deleteMessage"),
				whatsAppId: whatsAppId,
			});
		}

		setConfirmModalOpen(true);
	};

    const handleOpenQrModal = whatsApp => {
        setSelectedWhatsApp(whatsApp);
        setQrModalOpen(true);
    };

    const handleRequestNewQrCode = async whatsAppId => {
		try {
			await api.put(`/whatsappsession/${whatsAppId}`);
		} catch (err) {
            console.error({err});
			toastError(err);
		}
	};

    const handleSubmitConfirmationModal = async () => {
		if (confirmModalInfo.action === "disconnect") {
			try {
				await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
			} catch (err) {
                console.error({err});
				toastError(err);
			}
		}

		if (confirmModalInfo.action === "delete") {
			try {
				await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
				toast.success(i18n.t("connections.toasts.deleted"));
                // resetWpp();
			} catch (err) {
                console.error({err});
				toastError(err);
			}
		}

		setConfirmModalInfo(confirmationModalInitialState);
	};

    const renderActionButtons = whatsApp => {
        return (
          <>
            {whatsApp.status === "qrcode" &&
              (whatsApp.moduleId == "1" || whatsApp.moduleId == "4") && (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenQrModal(whatsApp)}
                  style={{
                    borderColor: !moduleIds.some((id) => [1, 4].includes(id))
                      ? "#bdbdbd"
                      : "#0B708C",
                    color: !moduleIds.some((id) => [1, 4].includes(id))
                      ? "#bdbdbd"
                      : "#0B708C",
                    border: "1px solid",
                    background: "transparent",
                  }}
                  disabled={!moduleIds.some((id) => [1, 4].includes(id))}
                >
                  {i18n.t("connections.buttons.qrcode")}
                </Button>
              )}
            {(whatsApp.status === "passkey" || whatsApp.status === "PAIRING") &&
              whatsApp.moduleId == "4" && (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenQrModal(whatsApp)}
                  style={{
                    borderColor: !moduleIds.some((id) => [4].includes(id))
                      ? "#bdbdbd"
                      : "#0B708C",
                    color: !moduleIds.some((id) => [4].includes(id))
                      ? "#bdbdbd"
                      : "#0B708C",
                    border: "1px solid",
                    background: "transparent",
                  }}
                  disabled={!moduleIds.some((id) => [4].includes(id))}
                >
                  {i18n.t("connections.buttons.qrcode")}
                </Button>
              )}
            {whatsApp.status === "DISCONNECTED" &&
              (whatsApp.moduleId == "1" || whatsApp.moduleId == "4") && (
                <>
                  {/* <Button
							size="small"
							variant="outlined"
							color="primary"
							onClick={() => handleStartWhatsAppSession(whatsApp.id)}
						>
							{i18n.t("connections.buttons.tryAgain")}
						</Button>{" "} */}
                  <Button
                    size="small"
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleRequestNewQrCode(whatsApp.id)}
                    style={{
                      borderColor: !moduleIds.some((id) => [1, 4].includes(id))
                        ? "#bdbdbd"
                        : "rgb(0, 168, 132)",
                      color: !moduleIds.some((id) => [1, 4].includes(id))
                        ? "#bdbdbd"
                        : "rgb(0, 168, 132)",
                    }}
                    disabled={!moduleIds.some((id) => [1, 4].includes(id))}
                  >
                    {i18n.t("connections.buttons.newQr")}
                  </Button>
                </>
              )}
            {whatsApp.status === "DISCONNECTED" && whatsApp.moduleId == "2" && (
              <>
                <FacebookLogin
                  appId={FACEBOOK_APP_ID} // Substitua pelo seu ID de aplicativo
                  autoLoad
                  scope="instagram_basic,pages_show_list,instagram_manage_messages,instagram_manage_insights,pages_manage_metadata,business_management,pages_messaging"
                  callback={(response) =>
                    responseFacebook(response, whatsApp.id)
                  }
                  disabled={moduleIds.includes(2) == false}
                  render={(renderProps) => (
                    <button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => handleFacebookLogin(renderProps)}
                      style={{
                        borderColor:
                          moduleIds.includes(2) == false
                            ? "#bdbdbd"
                            : "rgb(0, 168, 132)",
                        color:
                          moduleIds.includes(2) == false
                            ? "#bdbdbd"
                            : "rgb(0, 168, 132)",
                        border: "1px solid",
                        background: "transparent",
                      }}
                    >
                      {i18n.t("connections.buttons.loginFacebook")}
                    </button>
                  )}
                />
              </>
            )}
            {whatsApp.status === "DISCONNECTED" && whatsApp.moduleId == "3" && (
              <>
                <button
                  onClick={() => handleOpenWaPinModal(whatsApp.id)}
                  style={{
                    borderColor:
                      moduleIds.includes(3) == false
                        ? "#bdbdbd"
                        : "rgb(0, 168, 132)",
                    color:
                      moduleIds.includes(3) == false
                        ? "#bdbdbd"
                        : "rgb(0, 168, 132)",
                    border: "1px solid",
                    background: "transparent",
                  }}
                  disabled={moduleIds.includes(3) == false}
                >
                  {i18n.t("connections.buttons.loginFacebook")}
                </button>
              </>
            )}
            {(whatsApp.status === "CONNECTED" ||
              whatsApp.status === "PAIRING" ||
              whatsApp.status === "TIMEOUT") && (
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                style={{
                  borderColor: "#f50057",
                  color: "#f50057",
                }}
                onClick={() => {
                  handleOpenConfirmationModal("disconnect", whatsApp.id);
                }}
              >
                {i18n.t("connections.buttons.disconnect")}
              </Button>
            )}
            {whatsApp.status === "OPENING" && (whatsApp.moduleId == "1" || whatsApp.moduleId == "4")  && (
              <Button size="small" variant="outlined" disabled color="default">
                {i18n.t("connections.buttons.connecting")}
              </Button>
            )}
          </>
        );
    };

	const handleCloseQrModal = useCallback(() => {
		setSelectedWhatsApp(null);
		setQrModalOpen(false);
	}, [setQrModalOpen, setSelectedWhatsApp]);

    const handleCloseWhatsAppModal = useCallback(() => {
		// resetWpp()
		setWhatsAppModalOpen(false);
		setSelectedWhatsApp(null);
	}, [setSelectedWhatsApp, setWhatsAppModalOpen]);

    const handleEditWhatsApp = whatsApp => {
		setSelectedWhatsApp(whatsApp);
		setWhatsAppModalOpen(true);
	};

    const handleImportWhatsAppMessages = (whatsApp) => {
		setSelectedWhatsApp(whatsApp);
		setImportWhatsappMessages(true);
	};

    const handleCloseImportWhatsappMessages = () => {
        setSelectedWhatsApp(null);
        setImportWhatsappMessages(false);
    }

    const handleOpenImportSessionModal = (whatsApp) => {
        if (!CheckSupportEmail(user.email) || String(whatsApp?.moduleId) !== "4") return;
        setSelectedWhatsApp(whatsApp);
        setImportSessionJson("");
        setImportSessionModalOpen(true);
    };

    const handleCloseImportSessionModal = () => {
        if (importSessionLoading) return;
        setSelectedWhatsApp(null);
        setImportSessionJson("");
        setImportSessionModalOpen(false);
    };

    const handleImportWhatsMeowSession = async () => {
        if (!selectedWhatsApp?.id || importSessionLoading) return;

        let parsedSession;
        try {
            parsedSession = JSON.parse(importSessionJson);
        } catch (err) {
            toast.error("JSON da sessão inválido.");
            return;
        }

        try {
            setImportSessionLoading(true);
            await api.post(`/whatsappsession/${selectedWhatsApp.id}/import-whatsmeow-session`, {
                session: parsedSession,
            });
            toast.success("Sessão WhatsMeow importada. Aguarde a conexão iniciar.");
            setSelectedWhatsApp(null);
            setImportSessionJson("");
            setImportSessionModalOpen(false);
        } catch (err) {
            console.error({ err });
            toastError(err);
        } finally {
            setImportSessionLoading(false);
        }
    };

    return (
        <>
            <ConfirmationModal
                title={confirmModalInfo.title}
                open={confirmModalOpen}
                onClose={setConfirmModalOpen}
                onConfirm={handleSubmitConfirmationModal}
            >
                {confirmModalInfo.message}
            </ConfirmationModal>
            <QrcodeModal
                open={qrModalOpen}
                onClose={handleCloseQrModal}
                whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
            />
            <WhatsAppModal
                open={whatsAppModalOpen}
                onClose={handleCloseWhatsAppModal}
                whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
                userProfile={user.profile}
            />
            <ImportWhatsappMessageTableModal
                open={importWhatsappMessages == true ? true : false}
                onClose={handleCloseImportWhatsappMessages}
                id={selectedWhatsApp?.id}
            />
            <Dialog
                open={importSessionModalOpen}
                onClose={handleCloseImportSessionModal}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>Injetar sessão</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Cole o JSON da sessão. Esta ação é exclusiva do suporte e substitui as credenciais locais da conexão selecionada.
                    </Typography>
                    <TextField
                        label="JSON da sessão"
                        value={importSessionJson}
                        onChange={(e) => setImportSessionJson(e.target.value)}
                        multiline
                        minRows={12}
                        fullWidth
                        disabled={importSessionLoading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseImportSessionModal} disabled={importSessionLoading}>
                        Cancelar
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={handleImportWhatsMeowSession}
                        disabled={importSessionLoading || !importSessionJson.trim()}
                    >
                        {importSessionLoading ? "Importando..." : "Importar sessão"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={waPinModalOpen}
                onClose={() => {
                    setWaPinModalOpen(false);
                    waEmbedRef.current.pendingWhatsappId = null;
                }}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Crie um PIN para o WhatsApp Business</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Escolha um PIN de 6 dígitos"
                        type="text"
                        fullWidth
                        value={waBusinessPin}
                        onChange={(e) => setWaBusinessPin(String(e.target.value || "").replace(/\D/g, "").slice(0, 6))}
                        inputProps={{ maxLength: 6 }}
                        helperText="PIN de 6 dígitos para registrar números novos na Cloud API. Se o cliente conectar um número que já usa o app WhatsApp Business, a Meta pode ignorar o registro — guarde o PIN em local seguro."
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setWaPinModalOpen(false)} color="secondary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleStartWaEmbeddedSignup}
                        color="primary"
                        variant="contained"
                        disabled={waBusinessPin.length !== 6}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid container spacing={5}>
                <Grid item sm={12} xs={12} mb={2}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{i18n.t("connections.table.channel")}</TableCell>
                                <TableCell>{i18n.t("connections.table.name")}</TableCell>
                                <TableCell>{i18n.t("connections.table.status")}</TableCell>
                                <TableCell>{i18n.t("connections.table.session")}</TableCell>
                                <TableCell>{i18n.t("connections.table.number")}</TableCell>
                                <TableCell>{i18n.t("connections.table.option.title")}</TableCell>
                                <TableCell>{i18n.t("connections.table.lastUpdate")}</TableCell>
                                <TableCell>{i18n.t("connections.table.lastDisconnection")}</TableCell>
                                <Can
                                    role={user.profile}
                                    perform="connections-page:editOrDeleteConnection"
                                    yes={() => (
                                        <TableCell
                                            style={{ minWidth: "205px" }}
                                            align="center"
                                        >{i18n.t("connections.table.actions")}</TableCell>
                                    )}
                                />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredWhatsApps && filteredWhatsApps.map((whatsApp) => (
                                <TableRow>
                                    <TableCell>{(whatsApp.moduleId == 2) ? "Instagram" : "WhatsApp"}</TableCell>
                                    <TableCell>{whatsApp.name}</TableCell>
                                    <TableCell>{renderStatusToolTips(whatsApp)}</TableCell>
                                    <TableCell>{renderActionButtons(whatsApp)}</TableCell>
                                    <TableCell>{whatsApp.numberConnection}</TableCell>
                                    <TableCell>{i18n.t(`connections.table.option.${whatsApp.option}`)}</TableCell>
                                    <TableCell>{format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}</TableCell>
                                    <TableCell>{(whatsApp.disconnectedAt) ? format(parseISO(whatsApp.disconnectedAt), "dd/MM/yy HH:mm") : "Não se aplica."}</TableCell>
                                    <Can
                                        role={user.profile}
                                        perform="connections-page:editOrDeleteConnection"
                                        yes={() => (
                                            <TableCell align="center" style={{padding: 0}}>
                                                {
                                                    CheckSupportEmail(user.email) &&
                                                    <Button
                                                        title={i18n.t("connections.whatsapp.importMessages.buttons.importHistory")}
                                                        className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 ${classes.customButton}`}
                                                        disabled={whatsApp?.moduleId && (whatsApp.moduleId != "1" && whatsApp.moduleId != "4")}
                                                        onClick={() => {
                                                            if (whatsApp?.moduleId && (whatsApp.moduleId != "1" && whatsApp.moduleId != "4")) return;
                                                            handleImportWhatsAppMessages(whatsApp)
                                                        }}
                                                    >
                                                        <HistoryOutlinedIcon />
                                                    </Button>
                                                }
                                                {
                                                    CheckSupportEmail(user.email) && String(whatsApp.moduleId) === "4" &&
                                                    <Button
                                                        title="Injetar sessão"
                                                        className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 ${classes.customButton}`}
                                                        onClick={() => handleOpenImportSessionModal(whatsApp)}
                                                    >
                                                        <PublishIcon />
                                                    </Button>
                                                }
                                                <Button
                                                    title={i18n.t("buttons.edit")}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    onClick={() => handleEditWhatsApp(whatsApp)}
                                                    style={{ display: "inline-block" }}
                                                >
                                                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                                </Button>
                                                <Button
                                                    title={i18n.t("buttons.delete")}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    onClick={e => {
                                                        handleOpenConfirmationModal("delete", whatsApp.id);
                                                    }}
                                                    style={{ display: "inline-block" }}
                                                >
                                                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                                                </Button>
                                            </TableCell>
                                        )}
                                    />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        </>
    )
}

export default WhatsAppTable;